import { render, staticRenderFns } from "./h5Index.vue?vue&type=template&id=551fab31&scoped=true&"
import script from "./h5Index.vue?vue&type=script&lang=js&"
export * from "./h5Index.vue?vue&type=script&lang=js&"
import style0 from "./h5Index.vue?vue&type=style&index=0&id=551fab31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551fab31",
  null
  
)

export default component.exports